import { render, staticRenderFns } from "./h-transaction-edit.vue?vue&type=template&id=547b03d6&"
import script from "./h-transaction-edit.vue?vue&type=script&lang=js&"
export * from "./h-transaction-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports